const HaewaoIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="600"
            height="600"
            className={className}
            viewBox="0 0 600 600"
        >
            <path
                fill="currentColor"
                d="M217.4 209.3c1.3 2.4.9 5.5-1 7.5a119.6 119.6 0 0 0 51.4 198.4c2.6.8 4.5 3.2 4.5 5.9V490c0 3.6-3.3 6.5-7 5.8a198.6 198.6 0 0 1-91-347.6c2.7-2.3 6.9-1.5 8.7 1.6l34.4 59.5ZM492 324c3.6 0 6.3 3.1 5.8 6.7a198.7 198.7 0 0 1-159.7 165 5.8 5.8 0 0 1-6.8-5.8v-69c0-2.7 1.8-5 4.4-5.8 40.5-12 72-45 82-86.3a6.2 6.2 0 0 1 6-4.8H492ZM301.5 102c98.7 0 180.5 72 196 166.2a5.9 5.9 0 0 1-5.9 6.8h-68.5c-2.8 0-5.2-2-6-4.7A119.6 119.6 0 0 0 272 184.7c-2.7.7-5.6-.4-7-2.8l-34.3-59.5a5.8 5.8 0 0 1 3-8.5c21.1-7.7 44-11.9 67.8-11.9Z"
            />
        </svg>
    );
};

export default HaewaoIcon;
